import React from 'react'
import createReactClass from 'create-react-class'
import SearchContainer from '../containers/search-type-container'

export default createReactClass({
  render () {
    return (
      <section>
        <SearchContainer {...this.props}/>
      </section>
    )
  },
})



// WEBPACK FOOTER //
// ./src/views/search.js